__turbopack_context__.v({
  "Code": "JSONEditor-module-scss-module__y07CTq__Code",
  "CodeEditor": "JSONEditor-module-scss-module__y07CTq__CodeEditor",
  "Code___syntax": "JSONEditor-module-scss-module__y07CTq__Code___syntax",
  "Content": "JSONEditor-module-scss-module__y07CTq__Content",
  "ContentWrapper": "JSONEditor-module-scss-module__y07CTq__ContentWrapper",
  "Formatting": "JSONEditor-module-scss-module__y07CTq__Formatting",
  "FormattingWrapper": "JSONEditor-module-scss-module__y07CTq__FormattingWrapper",
  "InnerWrapper": "JSONEditor-module-scss-module__y07CTq__InnerWrapper",
  "InnerWrapper___error": "JSONEditor-module-scss-module__y07CTq__InnerWrapper___error",
  "Lines": "JSONEditor-module-scss-module__y07CTq__Lines",
  "Wrapper": "JSONEditor-module-scss-module__y07CTq__Wrapper",
});
